import { action, payload } from 'ts-action'
import { IGigDay } from '@network/models/gig-day.model'
import { IError, IPayload } from '@network/models/global.model'

export const GigDaysFetching = action('GigDaysFetching', payload<boolean>())

export const GetGigDays = action('GetGigDays', payload<IPayload<IGigDay[]>>())

export const GetGigDaysErrors = action('GetGigDaysErrors', payload<IError>())
